import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import InfoCard from "components/InfoCards/InfoCard";
import { storageOverviewMock } from "./mocks";
import { OVERVIEW_INFO_CARD_VARIANTS, OverviewInfoCardsConfig } from "./constants";

import styles from "./OverviewInfoCards.module.css";

const OverviewInfoCards: FC = () => {
  const { t } = useTranslation("storageOverview");

  return (
    <div className={styles.infoBoxContainer}>
      {OVERVIEW_INFO_CARD_VARIANTS.map((variant) => {
        const config = OverviewInfoCardsConfig[variant];
        const rawValue = storageOverviewMock[config.valueKey];
        const formattedValue = config.formatter ? config.formatter(rawValue) : String(rawValue);

        return (
          <InfoCard
            key={variant}
            title={t(config.labelPhrase)}
            tooltip={t(config.tooltipPhrase)}
            value={formattedValue}
            icon={config.icon}
            color={config.color}
            data-testid={`overview-info-card-${variant.toLowerCase()}`}
          />
        );
      })}
    </div>
  );
};

export default OverviewInfoCards;
